export const normalizeArray = (value) => {
    if (Array.isArray(value)) return value;

    return [value];
};
